import { Component, computed, input } from '@angular/core';
import type { FormControl } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';

import type { InterviewResultAnswerOption } from '@core/interview-results-types';
import type { SelectOption } from '@core/user-interface-legacy';
import { SelectComponent } from '@core/user-interface-legacy';

@Component({
  selector: 'rt-evaluation-dropdown-field',
  templateUrl: './evaluation-dropdown-field.component.html',
  styleUrls: ['./evaluation-dropdown-field.component.less'],
  imports: [ReactiveFormsModule, SelectComponent],
})
export class EvaluationDropdownFieldComponent {
  public readonly control = input.required<FormControl<string | null>>();
  public readonly required = input<boolean>(false);
  public readonly options = input<InterviewResultAnswerOption[]>([]);

  protected selectOptions = computed<SelectOption[]>(() =>
    this.options().map(option => ({ label: option.title, value: option.title })),
  );
}
